const accountQueryKeys = {
  account: ['account'] as const,
  stripe_customer: ['stripe_customer'] as const,
};
export default accountQueryKeys;
